export class InsuranceOptionsResponse {
    constructor(response) {
        if (!response) {
            throw new Error("Missing insurance options response data");
        }
        this.response = response;
    }
    getInsuranceOptions() {
        return this.response.insurances;
    }
}
